import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { GET_ADDRESS_BY_PINCODE, UPLOAD_DCUMENT, authKey, ResourceUpdateMember } from '../../../../common/URLs';
import { VEHICLE_INSURANCE, VEHICLE_NATIONAL_PERMIT, VEHICLE_PUCC, API_DATE_FORMAT, BASIC_DATE_FORMAT, EMPTY_FIELD_ERROR, UPLOAD_FILE_TEXT, FITNESS_NUMBER, WEIGHT_ERROR, UPDATE_POPOVER, CANCEL_POPOVER, ADD_POPOVER } from '../../../../common/constants';
import moment from 'moment';
import { VALIDATION } from '../../../../common/commonValidations';
import { FileUploadMUI } from "../../../../common/fileUpload/fileUploadMUI";
import { PROD } from '../../../../common/constants';
import { Container, Card, Button, CardContent, RadioGroup, Radio, FormGroup, FormLabel, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';

export const VehiclePopverDetails = (props) => {
    const [urn, setUrn] = useState();
    const { t } = useTranslation();
    const [vehicleType, setVehicleType] = useState('HCV');
    const [ownerType, setOwnerType] = useState('Owned');
    const [transporterDetails, setTransporterDetails] = useState();
    const [documentArray, setDocumentArray] = useState([]);
    const [id, setId] = useState('');
    const [grossVehicleWeight, setGrossVehicleWeight] = useState('');
    const [unLadenWeight, setUnLadenWeight] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');


    const [vehicleAge, setVehicleAge] = useState('');
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [insuranceNumber, setInsuranceNumber] = useState('');

    const [insuranceEndDate, setInsuranceEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [insuranceEndDateDisplay, setInsuranceEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [registrationEndDateDisplay, setRegistrationEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [registrationEndDate, setRegistrationEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [puccNumber, setPuccNumber] = useState('');
    const [puccNoEndDate, setPuccNoEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [puccNoEndDateDisplay, setPuccNoEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [fitnessNo, setFitnessNo] = useState('');
    const [fitnessEndDate, setFitnessEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [fitnessEndDateDisplay, setFitnessEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [isNationalPermitTrue, setNationalPermitTrue] = useState(false);
    const [isNationalPermitFalse, setNationalPermitFalse] = useState(true);
    const [permitNumber, setPermitNumber] = useState('');
    const [permitEndDate, setPermitEndDate] = useState(moment(new Date()).format(API_DATE_FORMAT));
    const [permitEndDateDisplay, setPermitEndDateDisplay] = useState(moment(new Date()).format(BASIC_DATE_FORMAT));
    const [errorMessage, setErrorMessage] = useState({
        vehicleWeightErr: '',
        unladenWeightErr: '',
        vehicleMakeErr: '',
        vehicleModelErr: '',
        vehicleAgeErr: '',
        registrationNumberErr: '',
        insuranceNumberErr: '',
        puccNumberErr: '',
        fitnessNumberErr: '',
        documentError: '',
        permitNumberError: '',
        nationalPermitDocError: ''
    });
    let checkUserDetails = localStorage.getItem('role');

    useEffect(() => {
        if (props.data) {
            setTransporterDetails(props.data)
            setUseStateData();
        }

    }, [transporterDetails])
    const setUseStateData = () => {
        if (transporterDetails) {
            console.log("transporterDetails", transporterDetails)
            let docType = transporterDetails?.documents
            let permitEndDateApiValue = transporterDetails?.nationalPermitEnddate ? transporterDetails?.nationalPermitEnddate : moment(new Date()).format(API_DATE_FORMAT)
            let insuranceEndDateApiValue = transporterDetails?.insuranceEnddate ? transporterDetails?.insuranceEnddate : moment(new Date()).format(API_DATE_FORMAT)
            let puccEndDateApiValue = transporterDetails?.puccEndDate ? transporterDetails?.puccEndDate : moment(new Date()).format(API_DATE_FORMAT)
            let fitnessEndDateApiValue = transporterDetails?.fitnessEndDate ? transporterDetails?.fitnessEndDate : moment(new Date()).format(API_DATE_FORMAT)
            let registrationEndDateApiValue = transporterDetails?.registrationEndDate ? transporterDetails?.registrationEndDate : moment(new Date()).format(API_DATE_FORMAT)
            setId(transporterDetails?.id ? transporterDetails?.id : null)
            setGrossVehicleWeight(transporterDetails?.grossVehicleWeight ? transporterDetails?.grossVehicleWeight : '')
            setUnLadenWeight(transporterDetails?.unladenWeight ? transporterDetails?.unladenWeight : '')
            setOwnerType(transporterDetails?.ownershipType ? transporterDetails?.ownershipType : 'Owned')
            setVehicleType(transporterDetails?.vehicleType ? transporterDetails?.vehicleType : 'HCV')
            setVehicleAge(transporterDetails?.vehicleAge ? transporterDetails?.vehicleAge : '')
            setRegistrationNumber(transporterDetails?.registrationNo ? transporterDetails?.registrationNo : '')
            setInsuranceNumber(transporterDetails?.insuranceNo ? transporterDetails?.insuranceNo : '')
            setPuccNumber(transporterDetails?.puccNo ? transporterDetails?.puccNo : '')
            setVehicleMake(transporterDetails?.vehicleMake ? transporterDetails?.vehicleMake : '')
            setVehicleModel(transporterDetails?.vehicleModel ? transporterDetails?.vehicleModel : '')
            setFitnessNo(transporterDetails?.fitnessNo ? transporterDetails?.fitnessNo : '')
            setNationalPermitTrue(transporterDetails?.isNationalPermitTrue ? transporterDetails?.isNationalPermitTrue : false)
            setPermitNumber(transporterDetails?.permitNumber ? transporterDetails?.permitNumber : '')
            //setting End Dates

            setPermitEndDate(permitEndDateApiValue ? permitEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
            setPermitEndDateDisplay(permitEndDateApiValue ? moment(permitEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setInsuranceEndDate(insuranceEndDateApiValue ? insuranceEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
            setInsuranceEndDateDisplay(insuranceEndDateApiValue ? moment(insuranceEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setPuccNoEndDate(puccEndDateApiValue ? puccEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
            setPuccNoEndDateDisplay(puccEndDateApiValue ? moment(puccEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setFitnessEndDate(fitnessEndDateApiValue ? fitnessEndDateApiValue : moment(new Date()).format(API_DATE_FORMAT))
            setFitnessEndDateDisplay(fitnessEndDateApiValue ? moment(fitnessEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setRegistrationEndDateDisplay(registrationEndDateApiValue ? moment(registrationEndDateApiValue).format(BASIC_DATE_FORMAT) : moment(new Date).format(BASIC_DATE_FORMAT))
            setDocumentArray(transporterDetails?.documents);
        }
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
    }
    const onNationlPermitRadio = (e, value) => {
        setNationalPermitTrue(value)
    }

    const grossVehicleWeightChange = (e) => {
        e.preventDefault();
        const slicedValue = VALIDATION.weightsSlicedValue(e.target.value);
        const vehicleWeightValidation = VALIDATION.weightsValidation(vehicleType, slicedValue)
        setGrossVehicleWeight(slicedValue)
        if (slicedValue.length == 0) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: 'Please enter Vehicle weight' })
        }
        else if (vehicleWeightValidation) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: vehicleWeightValidation })
        }
        else setErrorMessage({ ...errorMessage, vehicleWeightErr: "" })
    }

    const vehicleMakeChange = (e) => {
        e.preventDefault();
        setVehicleMake(e.target.value)
        if (e.target.value.length > 0) {
            setErrorMessage({ ...errorMessage, vehicleMakeErr: '' })
        } else setErrorMessage({ ...errorMessage, vehicleMakeErr: "Please enter Vehicle Make" })

    }
    const vehicleModelChange = (e) => {
        e.preventDefault();
        setVehicleModel(e.target.value)
        if (e.target.value.length > 0) {
            setErrorMessage({ ...errorMessage, vehicleModelErr: '' })
        } else setErrorMessage({ ...errorMessage, vehicleModelErr: "Please enter Vehicle Model" })

    }
    const registrationNumberChange = (e) => {
        let regvehiclecheck = props.vehicleDataReload ? props.vehicleDataReload : props?.regStakeholderMaster?.transporterVehicles;

        e.preventDefault();
        setRegistrationNumber(e.target.value.toUpperCase())
        if (registrationNumber.length > 0) {
            if (VALIDATION.registrationNumberValidation(e.target.value)) {
                if (props.actionType === "edit" && regvehiclecheck?.filter(item => (item.registrationNo == (e.target.value.toUpperCase()))).length == 0) {
                    setErrorMessage({ ...errorMessage, registrationNumberErr: '' })
                }
                else if (props.actionType === "add")
                    setErrorMessage({ ...errorMessage, registrationNumberErr: '' })

                else setErrorMessage({ ...errorMessage, registrationNumberErr: 'Registration No already exist' })
            } else setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })
        } else setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })

    }
    const insuranceNumberChange = (e) => {
        e.preventDefault();
        setInsuranceNumber(e.target.value.toUpperCase())
        if (insuranceNumber.length > 0) {
            setErrorMessage({ ...errorMessage, insuranceNumberErr: '' })
        } else setErrorMessage({ ...errorMessage, insuranceNumberErr: 'Please enter valid Insurance No.' })

    }
    const onPuccNumberChange = (e) => {
        e.preventDefault();
        setPuccNumber(e.target.value.toUpperCase())
        if (puccNumber.length > 0) {
            setErrorMessage({ ...errorMessage, puccNumberErr: '' })
        } else setErrorMessage({ ...errorMessage, puccNumberErr: 'Please enter valid PUCC No.' })

    }
    const onFitnessNumberChange = (e) => {
        e.preventDefault();
        setFitnessNo(e.target.value.toUpperCase())
        if (fitnessNo.length > 0) {
            setErrorMessage({ ...errorMessage, fitnessNumberErr: '' })
        } else setErrorMessage({ ...errorMessage, fitnessNumberErr: 'Please enter valid Fitness No.' })

    }
    const vehicleAgeChange = (e) => {
        e.preventDefault();
        setVehicleAge(e.target.value);
        if ((e.target.value.toString()).length > 0) {
            setErrorMessage({ ...errorMessage, vehicleAgeErr: '' })
        } else setErrorMessage({ ...errorMessage, vehicleAgeErr: "Please enter Vehicle Age" })

    }
    const unLadenWeightChange = (e) => {
        e.preventDefault();
        setUnLadenWeight(VALIDATION.weightsSlicedValue(e.target.value));
        if ((unLadenWeight.toString()).length > 5) {
            setErrorMessage({ ...errorMessage, unladenWeightErr: "Please enter Unladen Weight" })
        } else setErrorMessage({ ...errorMessage, unladenWeightErr: '' })

    }
    const onValidationCheck = (e) => {
        let regvehiclecheck = props.vehicleDataReload ? props.vehicleDataReload : props?.regStakeholderMaster?.transporterVehicles;
        let registrationDoc = documentArray && documentArray.filter((item) => item.documentType === "VehicleRegistration" && (item.isActive == 1 || item.isActive == 3));
        let insuranceDoc = documentArray && documentArray.filter((item) => item.documentType === VEHICLE_INSURANCE && (item.isActive == 1 || item.isActive == 3));
        let puccDoc = documentArray && documentArray.filter((item) => item.documentType === VEHICLE_PUCC && (item.isActive == 1 || item.isActive == 3));
        let fitnessDoc = documentArray && documentArray.filter((item) => item.documentType === FITNESS_NUMBER && (item.isActive == 1 || item.isActive == 3));
        let nationalPermitDoc = documentArray && documentArray.filter((item) => item.documentType === VEHICLE_NATIONAL_PERMIT && (item.isActive == 1 || item.isActive == 3));
        let vehicleWeightValidation = VALIDATION.weightsValidation(vehicleType, grossVehicleWeight)

        if ((grossVehicleWeight.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: "Please enter Vehicle Weight" });
            return;
        }
        else if (vehicleWeightValidation) {
            setErrorMessage({ ...errorMessage, vehicleWeightErr: vehicleWeightValidation })
            return;
        }
        else if ((unLadenWeight.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, unladenWeightErr: "Please enter Unladen Weight" });
            return;
        }
        else if (vehicleMake.length == 0) {
            setErrorMessage({ ...errorMessage, vehicleMakeErr: "Please enter Vehicle Make" });
            return;
        }
        else if (vehicleModel.length == 0) {
            setErrorMessage({ ...errorMessage, vehicleModelErr: "Please enter Vehicle Model" });
            return;
        }
        else if ((vehicleAge.toString()).length == 0) {
            setErrorMessage({ ...errorMessage, vehicleAgeErr: "Please enter Vehicle Age" })
            return;
        }
        else if (registrationNumber.length == 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: 'Please enter valid Registration Number' })
            return;
        }
        else if (!registrationDoc || registrationDoc.length == 0) {
            setErrorMessage({ registrationDocError: "Please upload registration certificate" });
            return;
        }
        else if (insuranceNumber.length == 0) {
            setErrorMessage({ ...errorMessage, insuranceNumberErr: 'Please enter valid Insurance No.' })
            return;
        }
        else if (!insuranceDoc || insuranceDoc.length == 0) {
            setErrorMessage({ insurenaceDocError: "Please upload insurance certificate" });
            return;
        }
        else if (puccNumber.length == 0) {
            setErrorMessage({ ...errorMessage, puccNumberErr: 'Please enter valid PUCC No.' })
            return;
        }
        else if (!puccDoc || puccDoc.length == 0) {
            setErrorMessage({ puccDocError: "Please upload pucc certificate" });
            return;
        }
        else if (!fitnessNo || fitnessNo.length == 0) {
            setErrorMessage({ ...errorMessage, fitnessNumberErr: 'Please enter valid Fitness No.' })
            return;
        }
        else if (!fitnessDoc || fitnessDoc.length == 0) {
            setErrorMessage({ fitnessDocError: "Please upload fitness certificate" });
            return;
        }
        else if (props.actionType === "edit" && errorMessage.registrationNumberErr?.length > 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: ' Registration Number already exists' })
            return;
        }
        else if (props.actionType === "add" && regvehiclecheck?.filter(item => (item.registrationNo == registrationNumber)).length > 0) {
            setErrorMessage({ ...errorMessage, registrationNumberErr: ' Registration Number already exists' });
            return;
        }
        else if (isNationalPermitTrue && permitNumber.length == 0) {
            setErrorMessage({ ...errorMessage, permitNumberError: 'Please enter permit number' });
            return;
        }
        else if (isNationalPermitTrue && (!nationalPermitDoc || nationalPermitDoc.length == 0)) {
            setErrorMessage({ nationalPermitDocError: "Please upload national permit certificate" });
            return;
        }
        else {
            onSubmitClick(e);
        }
    }
    const onSubmitClick = (e) => {
        e.preventDefault();
        if (transporterDetails?.id === null || transporterDetails?.id === undefined) {
            delete transporterDetails?.id
        }
        if (props.actionType === 'edit') {
            let dataToBePassed = {
                "id": transporterDetails?.id,
                "regTransporterMasterId": props?.regStakeholderMaster?.id,
                "vehicleType": vehicleType,
                "grossVehicleWeight": grossVehicleWeight,
                "unladenWeight": unLadenWeight,
                "vehicleMake": vehicleMake,
                "vehicleModel": vehicleModel,
                "vehicleAge": vehicleAge,
                "insuranceNo": insuranceNumber,
                "insuranceEnddate": insuranceEndDate,
                "puccNo": puccNumber,
                "puccEndDate": puccNoEndDate,
                "fitnessNo": fitnessNo,
                "fitnessEndDate": fitnessEndDate,
                "registrationEndDate": registrationEndDate,
                "isNationalPermitTrue": isNationalPermitTrue,
                "permitNumber": permitNumber,
                "nationalPermitEnddate": permitEndDate,
                "ownershipType": ownerType,
                "registrationNo": registrationNumber,
                "isActive": 1,
                "createdOn": transporterDetails.createdOn,
                "createdBy": transporterDetails.createdBy,
                "documents": documentArray ? documentArray : []
            }
            props.onSubmit(dataToBePassed);
            props.onClose();

        } else if (props.actionType === 'add') {
            let dataToBePassed = {
                "id": transporterDetails?.id ? transporterDetails?.id : uuidv4(),
                "regTransporterMasterId": props?.regStakeholderMaster?.id,
                "vehicleType": vehicleType,
                "grossVehicleWeight": grossVehicleWeight,
                "unladenWeight": unLadenWeight,
                "vehicleMake": vehicleMake,
                "vehicleModel": vehicleModel,
                "vehicleAge": vehicleAge,
                "insuranceNo": insuranceNumber,
                "insuranceEnddate": insuranceEndDate,
                "registrationEndDate": registrationEndDate,
                "puccNo": puccNumber,
                "puccEndDate": puccNoEndDate,
                "fitnessNo": fitnessNo,
                "fitnessEndDate": fitnessEndDate,
                "isNationalPermitTrue": isNationalPermitTrue,
                "permitNumber": permitNumber,
                "nationalPermitEnddate": permitEndDate,
                "ownershipType": ownerType,
                "registrationNo": registrationNumber,
                "isActive": 1,
                "documents": documentArray ? documentArray : []
            }
            props.onSubmit(dataToBePassed);
            props.onClose();
        }

    }
    const vehicleTypeChange = (e) => {
        setVehicleType(e.target.value);
    }

    const onweshipChange = (e) => {
        setOwnerType(e.target.value);

    }

    const onRegistrationEndDateChange = (e) => {
        setRegistrationEndDateDisplay(e.format(BASIC_DATE_FORMAT))
        setRegistrationEndDate(e.format(API_DATE_FORMAT))

    }
    const onNationPermitEndDateChange = (e) => {
        setPermitEndDateDisplay(e.format(BASIC_DATE_FORMAT))
        setPermitEndDate(e.format(API_DATE_FORMAT))

    }
    const onInsuranceEndDateChange = (e) => {
        setInsuranceEndDateDisplay(e.format(BASIC_DATE_FORMAT))
        setInsuranceEndDate(e.format(API_DATE_FORMAT))

    }
    const onPuccEndDateChange = (e) => {
        setPuccNoEndDateDisplay(e.format(BASIC_DATE_FORMAT))
        setPuccNoEndDate(e.format(API_DATE_FORMAT))

    }
    const onFinessEndDateChange = (e) => {
        setFitnessEndDateDisplay(e.format(BASIC_DATE_FORMAT))
        setFitnessEndDate(e.format(API_DATE_FORMAT))

    }

    const onPermitNumberChange = (e) => {
        e.preventDefault();
        setPermitNumber(e.target.value.toUpperCase())
        if ((e.target.value).length > 0) {
            setErrorMessage({ ...errorMessage, permitNumberError: '' })
        } else setErrorMessage({ ...errorMessage, permitNumberError: "Please enter permit number" })
    }

    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG25</p>}
                <Typography variant="h5" gutterBottom>
                    {t('reg.vehicleDetails')}
                </Typography>
                <Grid container spacing={2} direction="row" mt={1}>
                    <Grid item xs={12} lg={4}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <FormLabel>{t('reg.type')}</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel control={<Radio id="hcv" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleType" value="HCV" checked={vehicleType === "HCV"} onChange={(e) => vehicleTypeChange(e)} />} label={t('preReg.hcv')} />
                                        <FormControlLabel control={<Radio id="mcv" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleType" value="MCV" checked={vehicleType === "MCV"} onChange={(e) => vehicleTypeChange(e)} />} label={t('preReg.mcv')} />
                                        <FormControlLabel control={<Radio id="lcv" name="vehicleType" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value="LCV" checked={vehicleType === "LCV"} onChange={(e) => vehicleTypeChange(e)} />} label={t('preReg.lcv')} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <FormLabel>{t('reg.ownership')}</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel control={<Radio id="Owned" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="ownershipType" value="Owned" checked={ownerType === "Owned"} onChange={(e) => onweshipChange(e)} />} label={t('preReg.owned')} />
                                        <FormControlLabel control={<Radio id="Rented" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="ownershipType" value="Rented" checked={ownerType === "Rented"} onChange={(e) => onweshipChange(e)} />} label={t('preReg.rented')} />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth error={errorMessage.vehicleWeightErr} helperText={errorMessage.vehicleWeightErr} required type="number" onFocus={handleNumberFieldFocus} disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} label={t('reg.grossWeightinKg')} name="grossVehicleWeight" value={grossVehicleWeight} onChange={(e) => grossVehicleWeightChange(e)} inputProps={{
                                    maxLength: 10
                                }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required error={errorMessage.unladenWeightErr} helperText={errorMessage.unladenWeightErr} type="number" onFocus={handleNumberFieldFocus} label={t('reg.unladenWeight')} name="unladenWeight" value={unLadenWeight} disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} onChange={(e) => unLadenWeightChange(e)} inputProps={{
                                    maxLength: 10
                                }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.vehicleMakeErr} helperText={errorMessage.vehicleMakeErr} type="text" label={t('reg.vehicleMake')} disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} name="vehicleMake" value={vehicleMake} onChange={(e) => vehicleMakeChange(e)} inputProps={{
                                    maxLength: 20
                                }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.vehicleModelErr} helperText={errorMessage.vehicleModelErr} type="text" label={t('reg.vehicleModel')} name="vehicleModel" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value={vehicleModel} onChange={(e) => vehicleModelChange(e)} inputProps={{
                                    maxLength: 20
                                }} />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField fullWidth required error={errorMessage.vehicleAgeErr} helperText={errorMessage.vehicleAgeErr} type="number" onFocus={handleNumberFieldFocus} label={t('reg.vehicleAgeInYears')} name="vehicleAge" disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} value={vehicleAge} onChange={(e) => vehicleAgeChange(e)} inputProps={{
                                    maxLength: 5
                                }} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.registrationNumberErr} helperText={errorMessage.registrationNumberErr} disabled={((props.actionType === 'edit') && (ResourceUpdateMember.includes(checkUserDetails) && (checkUserDetails !== 'Reg-ITAdmin'))) ? true : false} type="text" label={t('reg.registrationNo')} placeholder="Eg: AS01BYXXXX." value={registrationNumber} onChange={(e) => registrationNumberChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key="VehicleRegistration"
                                    documentList={documentArray}
                                    documentType="VehicleRegistration"
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadVehicleRegistrationDoc')}
                                    stakeholderType="Transporter"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="registrationDocError"
                                // disabled={!ResourceUpdateMember.includes(checkUserDetails) ? true : false}
                                />
                                {/* <div className='mandatory_field'>{errorMessage.registrationDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.validTill')}
                                            name="registrationEndDate"
                                            value={registrationEndDateDisplay}
                                            onChange={(e) => onRegistrationEndDateChange(e)}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.insuranceNumberErr} helperText={errorMessage.insuranceNumberErr} type="text" label={t('reg.insuranceNo')} value={insuranceNumber} onChange={(e) => insuranceNumberChange(e)} inputProps={{
                                    maxLength: 20
                                }} />
                                <FileUploadMUI key={VEHICLE_INSURANCE}
                                    documentList={documentArray}
                                    documentType={VEHICLE_INSURANCE}
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadInsuranceDoc')}
                                    stakeholderType="Transporter"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="insurenaceDocError"
                                //disabled={!ResourceUpdateMember.includes(checkUserDetails) ? true : false}
                                />
                                {/* <div className='mandatory_field'>{errorMessage.insurenaceDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            label={t('reg.validTill')}
                                            name="insuranceEnddate"
                                            value={insuranceEndDateDisplay}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            onChange={(e) => onInsuranceEndDateChange(e)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.puccNumberErr} helperText={errorMessage.puccNumberErr} type="text" label={t('reg.puccNo')} value={puccNumber} onChange={(e) => onPuccNumberChange(e, 'no')} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key={VEHICLE_PUCC}
                                    documentList={documentArray}
                                    documentType={VEHICLE_PUCC}
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadPuccDoc')}
                                    stakeholderType="Transporter"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="puccDocError"
                                //disabled={!ResourceUpdateMember.includes(checkUserDetails) ? true : false}
                                />
                                {/* <div className='mandatory_field'>{errorMessage.puccDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            name="puccEndDate"
                                            label={t('reg.validTill')}
                                            value={puccNoEndDateDisplay}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            onChange={(e) => onPuccEndDateChange(e)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required error={errorMessage.fitnessNumberErr} helperText={errorMessage.fitnessNumberErr} type="text" label={t('reg.fitnessNo')} name="fitnessNo" value={fitnessNo} onChange={(e) => onFitnessNumberChange(e, 'no')} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key={FITNESS_NUMBER}
                                    documentList={documentArray}
                                    documentType={FITNESS_NUMBER}
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadFitnessDoc')}
                                    stakeholderType="Transporter"
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="fitnessDocError"
                                //disabled={!ResourceUpdateMember.includes(checkUserDetails) ? true : false}
                                />
                                {/* <div className='mandatory_field'>{errorMessage.fitnessDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            name="fitnessEndDate"
                                            label={t('reg.validTill')}
                                            value={fitnessEndDateDisplay}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            onChange={(e) => onFinessEndDateChange(e)}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth required>
                                    <FormLabel>{t('reg.nationalPermit')}</FormLabel>
                                    <RadioGroup row>
                                        <FormControlLabel control={<Radio id="yes" name="vehicleType" checked={isNationalPermitTrue === true} 
                                        onChange={(e) => onNationlPermitRadio(e, true)} />} label="Yes" />
                                        <FormControlLabel control={<Radio id="no" name="vehicleType" checked={isNationalPermitTrue === false} 
                                        onChange={(e) => onNationlPermitRadio(e, false)} />} label="No" />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField fullWidth required disabled={isNationalPermitTrue === false} error={errorMessage.permitNumberError} 
                                helperText={errorMessage.permitNumberError} type="text" placeholder={t('reg.permitNo')} value={permitNumber} 
                                onChange={(e) => onPermitNumberChange(e)} inputProps={{
                                    maxLength: 20,
                                    style: { textTransform: "uppercase" }
                                }} />
                                <FileUploadMUI key={VEHICLE_NATIONAL_PERMIT}
                                    documentList={documentArray}
                                    documentType={VEHICLE_NATIONAL_PERMIT}
                                    callBackDocumentUpload={onUploadCallBack}
                                    stakeholderDetailId={props.regID}
                                    title={t('reg.uploadNationalPermitDoc')}
                                    stakeholderType="Transporter"
                                    disabled={isNationalPermitTrue === false}
                                    errorMessage={errorMessage}
                                    setErrorMessage={setErrorMessage}
                                    documentError="nationalPermitDocError"
                                />
                                {/* <div className='mandatory_field'>{errorMessage.nationalPermitDocError}</div> */}
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            inputFormat="DD/MM/YYYY"
                                            renderInput={(params) => <TextField {...params} />}
                                            sx={{ minWidth: 750 }}
                                            value={permitEndDateDisplay}
                                            label={t('reg.validTill')}
                                            onChange={(e) => onNationPermitEndDateChange(e)}
                                            minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                            disabled={isNationalPermitTrue === false}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
            <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                <Button sx={{ minWidth: 100 }} variant="contained" onClick={props.onClose}>{t('reg.cancel')}</Button>
                <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => onValidationCheck(e)}>{props.actionType === "add" ? t('reg.add') : t('reg.update')}</Button>
            </Box>
        </>
    )

}